const dev = {
  // API_ENDPOINT_URL: "https://local.bngsystem.com:8000/api",
  API_ENDPOINT_URL: "http://localhost:8000/api",
};

const prod = {
  // API_ENDPOINT_URL: "https://backend.bngsystem.com/api",
  API_ENDPOINT_URL: "https://frontend.advancarelab.com/api", // reverse proxy applied for this
};

const test = {
  API_ENDPOINT_URL: "https://backend.bngsystem.com/api",
  // API_ENDPOINT_URL: "https://frontend.advancarelab.com/api",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};
export const APP_NAME = "Advancare";
export const ALLOWED_FOR_AGENCIES = false;
export const env = getEnv();
